import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import { useTranslation } from "../language";
import { Stack } from "./stack";

const Styled = styled.div`
  cursor: pointer;
  background-color:${props => props.theme.main};
  color: white;
  width:100%;
  max-width: 400px;
  border-radius: 5px;
  border: 2px solid ${props => props.theme.main};
  
  h2 {
    text-align:center;
  }
`;

export const BackButton = () => {

  const navigate = useNavigate();
  const translate = useTranslation();

  return (
    <Stack horizontal style={{ padding: 20 }} horizontalAlign="center">
      <Styled onClick={() => navigate('/', { replace: true })}>
        <h2>{translate("Common.Back")}</h2>
      </Styled>
    </Stack>
  )
}